import { keyBy } from 'lodash';
import { WEBSITE_FLOW } from './website-flow';

export interface IPlatform {
    id: string;
    displayName: string;
}

/* TODO: Delete PS3, X360 and Wii U after ~2.7.2 */
export enum PLATFORM_TYPES {
    PC = 'PC',
    PS4 = 'PS4',
    XONE = 'XONE',
    SWITCH = 'SWITCH',
    PS3 = 'PS3',
    X360 = 'X360',
    WIIU = 'WIIU',
    WEB = 'WEB',
    MOBILE = 'MOBILE',
    IOS = 'IOS',
    ANDROID = 'ANDROID',
    OCULUSVR = 'OCULUSVR',
    STEAMVR = 'STEAMVR',
    STEAM = 'STEAM',
    EPIC = 'EPIC',
    STADIA = 'STADIA',
    PS5 = 'PS5',
    XSX = 'XSX',
    LUNA = 'LUNA',
    AMAZON = 'AMAZON',
    SIGNUP = 'SIGNUP'
}

export const LINKABLE_PLATFORMS = [PLATFORM_TYPES.PS4, PLATFORM_TYPES.XONE];

export const PLATFORM_XBOX_ONE = 'XboxOne';
export const PLATFORM_XBOX_SERIES = 'XboxSeriesX';

const PLATFORMS: Array<IPlatform> = [
    {
        id: PLATFORM_TYPES.PC,
        displayName: PLATFORM_TYPES.PC
    },
    {
        id: PLATFORM_TYPES.PS4,
        displayName: PLATFORM_TYPES.PS4
    },
    {
        id: PLATFORM_TYPES.XONE,
        displayName: PLATFORM_TYPES.XONE
    },
    {
        id: PLATFORM_TYPES.SWITCH,
        displayName: PLATFORM_TYPES.SWITCH
    },
    {
        id: PLATFORM_TYPES.XSX,
        displayName: PLATFORM_TYPES.XSX
    },
    {
        id: PLATFORM_TYPES.PS5,
        displayName: PLATFORM_TYPES.PS5
    }
];

const REDEEM_PLATFORMS: Array<IPlatform> = [
    ...PLATFORMS,
    {
        id: PLATFORM_TYPES.EPIC,
        displayName: PLATFORM_TYPES.EPIC
    },
    {
        id: PLATFORM_TYPES.STADIA,
        displayName: PLATFORM_TYPES.STADIA
    },
    {
        id: PLATFORM_TYPES.LUNA,
        displayName: PLATFORM_TYPES.LUNA
    }
];

const REDEEM_PLATFORMS_V1: Array<IPlatform> = [
    ...REDEEM_PLATFORMS,
    {
        id: PLATFORM_TYPES.IOS,
        displayName: PLATFORM_TYPES.IOS
    },
    {
        id: PLATFORM_TYPES.ANDROID,
        displayName: PLATFORM_TYPES.ANDROID
    }
];

const PYC_REDEEM_PLATFORMS: Array<IPlatform> = [
    {
        id: PLATFORM_TYPES.PC,
        displayName: PLATFORM_TYPES.PC
    },
    {
        id: PLATFORM_TYPES.EPIC,
        displayName: PLATFORM_TYPES.EPIC
    }
];

export const BETA_PLATFORMS_V2: Array<IPlatform> = [
    ...PLATFORMS,
    {
        id: PLATFORM_TYPES.LUNA,
        displayName: PLATFORM_TYPES.LUNA
    },
    {
        id: PLATFORM_TYPES.IOS,
        displayName: PLATFORM_TYPES.IOS
    },
    {
        id: PLATFORM_TYPES.ANDROID,
        displayName: PLATFORM_TYPES.ANDROID
    },
    {
        id: PLATFORM_TYPES.OCULUSVR,
        displayName: PLATFORM_TYPES.OCULUSVR
    },
    {
        id: PLATFORM_TYPES.STEAMVR,
        displayName: PLATFORM_TYPES.STEAMVR
    },
    {
        id: PLATFORM_TYPES.EPIC,
        displayName: PLATFORM_TYPES.EPIC
    }
];

export const BETA_PLATFORMS: Array<IPlatform> = [
    ...BETA_PLATFORMS_V2,
    {
        id: PLATFORM_TYPES.STADIA,
        displayName: PLATFORM_TYPES.STADIA
    },
    {
        id: PLATFORM_TYPES.WEB,
        displayName: PLATFORM_TYPES.WEB
    },
    {
        id: PLATFORM_TYPES.MOBILE,
        displayName: PLATFORM_TYPES.MOBILE
    },
    {
        id: PLATFORM_TYPES.AMAZON,
        displayName: PLATFORM_TYPES.AMAZON
    }
];

const FRIENDS_REFERRAL_PLATFORMS: Array<IPlatform> = [
    ...PLATFORMS,
    {
        id: PLATFORM_TYPES.STADIA,
        displayName: PLATFORM_TYPES.STADIA
    }
];

const BETA_REGISTRATION_V2_PLATFORMS: Array<IPlatform> = [
    ...BETA_PLATFORMS_V2,
    {
        id: PLATFORM_TYPES.SIGNUP,
        displayName: PLATFORM_TYPES.SIGNUP
    }
];

const DEFAULT_PLATFORMS: Array<IPlatform> = [
    ...PLATFORMS,
    {
        id: PLATFORM_TYPES.LUNA,
        displayName: PLATFORM_TYPES.LUNA
    }
];

export const PLATFORMS_BY_WEBSITE_FLOW = (flow?: WEBSITE_FLOW): Array<IPlatform> => {
    switch (flow) {
    case WEBSITE_FLOW.BETA_REGISTRATION:
    case WEBSITE_FLOW.BETA_APPROVAL:
        return BETA_PLATFORMS;
    case WEBSITE_FLOW.BETA_REGISTRATION_V2:
        return BETA_REGISTRATION_V2_PLATFORMS;
    case WEBSITE_FLOW.BETA_APPROVAL_V2:
    case WEBSITE_FLOW.BETA_GUARANTEED_ACCESS_V2:
        return BETA_PLATFORMS_V2;
    case WEBSITE_FLOW.ULC_REDEEM:
    case WEBSITE_FLOW.CF_REDEEM:
        return REDEEM_PLATFORMS_V1;
    case WEBSITE_FLOW.CF_REDEEM_V2:
    case WEBSITE_FLOW.PYC_REDEEM_V2:
        return REDEEM_PLATFORMS;
    case WEBSITE_FLOW.PYC_REDEEM:
        return PYC_REDEEM_PLATFORMS;
    case WEBSITE_FLOW.FRIENDS_REFERRAL:
        return FRIENDS_REFERRAL_PLATFORMS;
    default:
        return DEFAULT_PLATFORMS;
    }
};

export const DEFAULT_WEBSITE_PLATFORM_SELECTION_ENUM = [
    PLATFORM_TYPES.PC,
    PLATFORM_TYPES.PS4,
    PLATFORM_TYPES.XONE
];

export const DEFAULT_PYC_REDEEM_PLATFORM_SELECTION_ENUM = [ PLATFORM_TYPES.PC ];

export const DEFAULT_CF_REDDEM_PLATFORM_SELECTION_ENUM = [
    ...DEFAULT_WEBSITE_PLATFORM_SELECTION_ENUM,
    PLATFORM_TYPES.STADIA,
    PLATFORM_TYPES.PS5,
    PLATFORM_TYPES.XSX
];
export const WEBSITE_PLATFORM_SELECTION_ENUM = DEFAULT_PLATFORMS.map(({ id }) => id);
export const PLATFORMS_BY_PLATFORM_ID: { [id: string]: IPlatform } = keyBy(BETA_PLATFORMS, 'id');

/* It's Used as attribute on Platform selection screen */
export const DATA_PLATFORMS_AMOUNT = 'data-platforms-amount';
